define((require) => {
    "use strict";

    const _                   = require("underscore");
    const AbstractWidgetModel = require("shared/ui/experience/widgets/AbstractWidgetModel");
    const WidgetScaleMode     = require("shared/ui/experience/widgets/WidgetScaleMode");

    /**
     * Model for a social sharing widget.
     *
     * @class SocialSharingWidgetModel
     */
    return AbstractWidgetModel.extend("Social sharing", {
        defaults: _.defaults({
            type: "social-sharing",
            url: null,
            style: "flat-squared",
            networks: ["facebook", "twitter", "linkedin", "pinterest"],
            // The Social Sharing widget will be stretched (scaled) when the Experience is
            // resized. When we get a proper responsive widget layout in place, this should be removed.
            scaleMode: WidgetScaleMode.STRETCH
        }, AbstractWidgetModel.prototype.defaults),

        getScaledSize() {
            // Scaling is not supported by the Social Sharing widget - sizing is
            // determined by the 'size' property and the number of scenes.
            return {};
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/socialSharingWidget/SocialSharingWidgetModel.js